import { useQuery } from "@tanstack/react-query";
import { usePartyApi } from "../api/party-api";
import type {
  CustomerClaim,
  CustomerHousehold,
  CustomerPolicy,
  CustomerRenewal,
} from "../api/contracts";

// The customer portfolio reads (N1/N2/N4/N5) — self-scope @PartyOnly reads. All return the
// party's own data (empty arrays until RICH-2 seeds policies/claims); no retry (a miss is a
// state, not a transient). The surfaces render calm empty-states over these.

/** GET /v1/customer/policies (N1). */
export function usePolicies() {
  const api = usePartyApi();
  return useQuery({
    queryKey: ["customer", "policies"],
    queryFn: () => api.get<CustomerPolicy[]>("/v1/customer/policies"),
    retry: false,
  });
}

/** GET /v1/customer/household (N2). */
export function useHousehold() {
  const api = usePartyApi();
  return useQuery({
    queryKey: ["customer", "household"],
    queryFn: () => api.get<CustomerHousehold>("/v1/customer/household"),
    retry: false,
  });
}

/** GET /v1/customer/renewals (N4). */
export function useRenewals() {
  const api = usePartyApi();
  return useQuery({
    queryKey: ["customer", "renewals"],
    queryFn: () => api.get<CustomerRenewal[]>("/v1/customer/renewals"),
    retry: false,
  });
}

/** GET /v1/customer/claims (N5). */
export function useClaims() {
  const api = usePartyApi();
  return useQuery({
    queryKey: ["customer", "claims"],
    queryFn: () => api.get<CustomerClaim[]>("/v1/customer/claims"),
    retry: false,
  });
}
